import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Product, useProducts } from '../../services';
import { colors } from '../../utils';

const CASH_APP_CASHTAG = 'NMZLakeland';

const Orders = () => {
  const { busy, products } = useProducts();
  const [cashAppProduct, setCashAppProduct] = useState<Product | null>(null);

  const cashAppLink = cashAppProduct
    ? `https://cash.app/$${CASH_APP_CASHTAG}/${cashAppProduct.price.toFixed(2)}`
    : '';

  return (
    <div className="orders">
      <div className="contactus-hero" style={{ height: 80 }}>
        Order Products
      </div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          margin: '2rem',
        }}
      >
        {busy && (
          <Box
            sx={{ display: 'flex', justifyContent: 'center', margin: '2rem' }}
          >
            <CircularProgress sx={{ color: colors.themeRed }} />
          </Box>
        )}

        {!busy && products.length === 0 && (
          <Box sx={{ textAlign: 'center', color: '#888' }}>
            There are no products available to order right now.
          </Box>
        )}

        {!busy && products.length > 0 && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            {products.map((product) => (
              <Card
                key={product.id}
                sx={{
                  padding: 0,
                  margin: 2,
                  maxWidth: {
                    md: '350px',
                    xs: '400px',
                  },
                }}
              >
                {product.imageUrl && (
                  <CardMedia
                    component="img"
                    height="200"
                    image={product.imageUrl}
                    alt={product.name}
                  />
                )}
                <CardContent sx={{ textAlign: 'center' }}>
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: '1.1rem',
                      margin: '0.5rem 0',
                    }}
                  >
                    {product.name}
                  </div>
                  {!!product.description && (
                    <div
                      style={{
                        color: '#888',
                        marginBottom: '0.5rem',
                      }}
                    >
                      {product.description}
                    </div>
                  )}
                  {!!product.price && (
                    <div
                      style={{
                        color: colors.themeRed,
                        fontWeight: 'bold',
                        marginBottom: '1rem',
                      }}
                    >
                      ${product.price.toFixed(2)}
                    </div>
                  )}
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1,
                    }}
                  >
                    {product.orderLink && (
                      <Button
                        variant="outlined"
                        sx={{
                          color: colors.themeRed,
                          borderColor: colors.themeRed,
                        }}
                        href={product.orderLink}
                      >
                        Order with Vanco
                      </Button>
                    )}
                    {!!product.price && (
                      <Button
                        variant="contained"
                        onClick={() => setCashAppProduct(product)}
                      >
                        Order with Cash App
                      </Button>
                    )}
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>

      <Dialog
        open={!!cashAppProduct}
        onClose={() => setCashAppProduct(null)}
        aria-labelledby="cash-app-dialog-title"
      >
        <DialogTitle id="cash-app-dialog-title">Pay with Cash App</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please include your name, “{cashAppProduct?.name}“ and color/size in
            the Cash App payment notes so we can match your payment to your
            order.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCashAppProduct(null)}>Cancel</Button>
          <Button
            variant="contained"
            // sx={{ backgroundColor: colors.themeRed }}
            href={cashAppLink}
            target="_blank"
            rel="noreferrer"
            onClick={() => setCashAppProduct(null)}
          >
            Open Cash App
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Orders;
